export default __webpack_public_path__ + "static/media/like-heart.054078b0.svg";